<template>
    <BlockList :blocks="content.blocks"
               :enable-container="false"/>
</template>

<script setup lang="ts">
import { PropType } from 'vue';
import { BaseContentModel } from '@/types/contentServerContract';

const props = defineProps({
    content: { type: Object as PropType<BaseContentModel>, required: true }
});
</script>
